import * as React from "react";
import { reducer, initState } from "../../../../reducers/report/latest/exective";
import { Loading } from "../../../../../../react-components/lu-component/src/index";
import { ConfirmBox } from "../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../lib/request";
import { replaceEndpointUrl, v3ApiEndpoint } from "../../../../../../server/router/endpoint";
import { useNavigate, useParams } from "react-router-dom";
import { GetExecutiveResportResponseV3 } from "../../../../../../server/types/request/report/exective";
import { ExecutiveReportLatestPage } from "../../../../components/pages/report/latest/executive-report";

import { clientEndpoint } from "../../../../routes/endpoint";
import { ReportBigTitle } from "../../../../components/pages/report/parts/report-title";

export const ExectiveReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, goalSalesVolume, data } = state;
	const navigate = useNavigate();
	const { jobId, activityId } = useParams<{
		jobId: string;
		activityId: string;
	}>();
	React.useEffect(() => {
		get<GetExecutiveResportResponseV3>(`${v3ApiEndpoint.executiveReport}/${jobId}`)
			.then((response) => {
				dispatch({ type: "loadData", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			})
			.then(() => {
				dispatch({ type: "changeLoading", payload: false });
			});
	}, [jobId]);
	const onSimulationPage = React.useCallback(
		() => navigate(replaceEndpointUrl(clientEndpoint.simulationReportLatest, { jobId, activityId })),
		[activityId, jobId, navigate],
	);
	return (
		<>
			<Loading loading={loading} />
			<ConfirmBox info={info} />
			{goalSalesVolume &&
				data.map((d, index) => {
					return (
						<React.Fragment key={`exective-${index}`}>
							<ReportBigTitle>
								{index === 0 ? "エグゼクティブサマリー" : "前回テストのエグゼクティブサマリー"}（{d.job.jobNum}）
							</ReportBigTitle>
							<ExecutiveReportLatestPage {...d} goalSalesVolume={goalSalesVolume} onSimulationPage={onSimulationPage} />
						</React.Fragment>
					);
				})}
		</>
	);
};
